<template>
	<div>
		<b-modal :hideHeaderClose="!isMobile()" hide-footer @hide="clearFields" ref="modal-primary" id="modal-primary"
			@cancel="clearFields" @close="clearFields" size="xl" modal-class="modal-primary" centered v-if="data"
			:title="$t('AddNew') + ' ' + $t('CargoDefinationId')">
			<b-row>
				<b-col lg="6" sm="12">
					<vs-card>
						<b-row>
							<b-col>
								<b-row class="mt-2">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('ShippingType')" class="vs-input--label pr-0 mr-0"
											label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="shippingType" type="text" class="w-full" name="shippingType"
											v-validate="'required'" />
										<span class="text-danger text-sm" v-show="errors.has('shippingType')">{{ errors.first('shippingType')
										}}</span>
									</b-col>
								</b-row>

								<b-row class="mt-2">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('ShippingDay')" class="vs-input--label pr-0 mr-0"
											label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="shippingDay" type="number" class="w-full" v-validate="'required'"
											name="shippingDay" />
										<span class="text-danger text-sm" v-show="errors.has('shippingDay')">{{ errors.first('shippingDay')
										}}</span>
									</b-col>
								</b-row>
								<b-row class="mt-2">
									<b-col cols="4" align-self="center">
										<b-form-group :label="'* ' + $t('Price')" class="vs-input--label pr-0 mr-0" label-for="h-first-name">
										</b-form-group>
									</b-col>
									<b-col cols="8">
										<vs-input size="small" v-model="price" type="number" class="w-full" v-validate="'required'"
											name="price" />
										<span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>
									</b-col>
								</b-row>
							</b-col>
						</b-row>


						<div class="items-center pl-6  mt-5 mb-0">
							<b-row align-h="end">
								<b-col cols="3" md="auto" style=" padding: 0px;">
									<b-button class="bg-danger" style=" border-color:white;" v-on:click="initValues">
										<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t('Cancel') }}
									</b-button>
								</b-col>
								<b-col cols="3" md="auto">
									<b-button class="bg-primary" style=" border-color:white;" v-on:click="submitData()">
										<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t('Save') }}
									</b-button>
								</b-col>
							</b-row>
						</div>
					</vs-card>
				</b-col>
				<b-col  lg="6" sm="12">
					<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new" :settings="settings"
						:key="$vs.rtl">
						<b-row style="padding:10px">
							<b-col lg="6" sm="12" v-for="item in cargoList" :key="item.CargoDefinationId"
								:value="item.CargoDefinationId">
								<vs-card>
									<b-row class="justify-content-md-end">
										<b-col cols="12" md="auto" style="margin:0px; padding: 0px">
											<b-button variant="outline-light" @click=" setDataValues(item);"
												style="border: none; background: none; margin-right:0px; padding-right: 0px ">
												<Icon icon="ep:edit" color="#7367F0" width="18" height="18"
													v-b-tooltip.hover.bottom="'Güncelle'" />
											</b-button>
										</b-col>
										<b-col cols="12" md="auto" style="margin:0px; padding: 0px">
											<b-button variant="outline-light" @click=" deleteCargo(item.CargoDefinationId);"
												style="border: none; background: none; ">
												<Icon icon="ph:trash-fill" color="#FF9F43" width="18" height="18"
													v-b-tooltip.hover.bottom="'Sil'" />
											</b-button>
										</b-col>
									</b-row>
									<h6><span class="text-danger">{{ $t('ShippingType') }} : </span>{{ item.ShippingType }}</h6>
									<h6><span class="text-danger">{{ $t('ShippingDay') }} : </span>{{ item.ShippingDay }}</h6>
									<h6><span class="text-danger">{{ $t('Price') }} : </span>{{ item.price }}</h6>
								</vs-card>
							</b-col>
						</b-row>
					</component>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>
<script>
import { Validator } from "vee-validate";
import { uuid } from "vue-uuid";
import { Icon } from "@iconify/vue2";
import { isMobile } from "mobile-device-detect";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
	components: { VuePerfectScrollbar, Icon },
	props: {
		isPromptCargoActive: {
			type: Boolean,
			required: true
		},
		data: {
			default: () => { },
		},
	},
	data() {
		return {
			cargoList: "",
			cargoDefinationId: "",
			shippingType: "",
			shippingDay: "",
			price: "",
			isMobile: function () {
				return isMobile;
			},
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60
			},
		}
	},
	methods: {
		deleteCargo(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("storehouse/deleteCargo", data)
				.then(response => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							this.getCargoDefinitionList();

						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		setDataValues(item) {
			console.log(item)
			this.cargoDefinationId = item.CargoDefinationId;
			this.shippingType = item.ShippingType;
			this.shippingDay = item.ShippingDay;
			this.price = item.price;

		},
		getCargoDefinitionList() {
			this.$store.dispatch("storehouse/listCargoForDepot", this.data.DepotId).then(response => {
				console.log(response)
				this.cargoList = this.cargo;
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					this.cargoList = this.cargo;
				} else
					console.log(response.statusText)
				/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
			});
		},
		submitData() {
			var createdId = uuid.v4();
			const vs = this.$vs;
			this.$validator.validateAll().then(result => {
				if (result) {
					// if form have no errors

					let obj = {
						cargoDefinationId: this.cargoDefinationId != "" ? this.cargoDefinationId : createdId,
						price: this.price,
						shippingType: this.shippingType,
						shippingDay: this.shippingDay,
						companyId: this.data.CompanyId,
						depotId: this.data.DepotId
					}
					console.log(obj)
					if (this.cargoDefinationId != "") {
						this.$store.dispatch('storehouse/updateCargo', obj).then(response => {
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.initValues()
								this.getCargoDefinitionList();
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					} else {
						delete obj.id
						obj.popularity = 0
						this.$store.dispatch('storehouse/addCargo', obj).then(response => {
							console.log(response)
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.initValues()
								this.getCargoDefinitionList();
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					}
				} else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})
		},
		initValues() {
			this.cargoDefinationId = "";
			this.price = "";
			this.shippingType = "";
			this.shippingDay = "";
		},
		clearFields() {
			this.$root.$emit("closeCargoData");
			this.shippingType = "";
			this.shippingDay = "";
			this.price = "";
		},
	},
	watch: {
		isPromptCargoActive(val) {
			if (val)
				this.$refs["modal-primary"].show();
			else this.$refs["modal-primary"].hide();
			this.getCargoDefinitionList();
			if (!val) return
			return val
		},
	},
	computed: {
		cargo: {
			get() {
				return this.$store.state.storehouse.Cargo;
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
		scrollbarTag() { return this.$store.getters.scrollbarTag },
		isSidebarActiveLocal: {
			get() {
				return this.isPromptCargoActive
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},
	},
	created() {
		const dict = {
			custom: {
				shippingType: {
					required: this.$t('shippingTypeRequired'),
					alpha: this.$t('shippingTypeRequired')
				}, shippingDay: {
					required: this.$t('shippingDayRequired'),
					alpha: this.$t('shippingDayRequired')
				}, price: {
					required: this.$t('priceRequired'),
					alpha: this.$t('priceRequired')
				}

			}
		};
		Validator.localize("en", dict);
	}
}
</script>

<style lang="scss" scoped>
.vs-input--label {
	color: black;
	font-size: small;
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 130px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

[dir] .modal-title {
	margin-bottom: 0;
	color: #7367f0 !important;
}

#modal-primary___BV_modal_outer_ {
	z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
	background-color: #f8f8f8;
	border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
	border-top-left-radius: calc(0.358rem - 1px);
	border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
	padding: 0.8rem 1.4rem;
	border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
	-webkit-transform: translate(5px, 3px);
	transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.modal.modal-primary .modal-header .close {
	color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
	opacity: 1;
	outline: none;
}

[dir="ltr"] .modal-header .close {
	margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
	padding: 0.2rem 0.62rem;
	-webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
	box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
	border-radius: 0.357rem;
	background: #fff;
}

.modal-header {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	-ms-flex-align: start;
	align-items: flex-start;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
}</style>